import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class Message extends Component {
  constructor(props) {
    super(props);

    this.types = {
      warning: 'exclamation-triangle',
    };
  }
  render() {
    if (!(this.props.type in this.types)) {
      throw new ReferenceError('<Message> has encountered an unexpected type');
    }

    return (
      <div className={`alert alert-${this.props.type} text-center`}>
        {this.types[this.props.type]
          ? <FontAwesomeIcon icon={this.types[this.props.type]} />
          : null}
        {this.props.children || this.props.text}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Message/Message.js